
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curated/[slug]",
      function () {
        return require("private-next-pages/curated/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curated/[slug]"])
      });
    }
  